// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__34Y6I","filesListContainer":"PosDisputesFiles_filesListContainer__3_dVA","filesButton":"PosDisputesFiles_filesButton__1gU4-"};